<template xmlns="http://www.w3.org/1999/html">
    <input type="text"
           :data-inputmask-alias="inputmask"
           ref="date"
           :name="name"
           v-model="date"
    >
</template>

<script>
    export default {
        name: 'DatePicker',
        props: {
            inputmask: {
                type: String,
                default: 'dd.mm.yyyy'
            },
            name: {}
        },
        data() {
            return {
                date: ''
            };
        },
        mounted() {
            let config = {
                format: 'dd.mm.yyyy',
                todayHighlight: true,
                autoclose: true,
            };
            $(this.$refs.date).datepicker(config)
                .on('changeDate', (event) => {
                    this.date = event.target.value;
                    this.$parent.$emit('change_' + this.name, event.target.value);
                });

            $(this.$refs.date).on('change', (event) => {
                this.date = event.target.value;
                this.$parent.$emit('change_' + this.name, event.target.value);
            });
        }
    };
</script>
<style lang="less">
    @import "../../../../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css";
</style>



// WEBPACK FOOTER //
// DatePicker.vue?46aa0ca6